var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { nanoid } from "@reduxjs/toolkit";
import axios from "axios";
import dayjs from "dayjs";
import { Config } from "../../../../api/config";
import { getAppointmnetSlotsUrl, getSlotAPI } from "../../../../api/url";
import { showError, showSuccess } from "../../../../redux/commonSlice";
import { createAPI, getByIdAPI, setReducerState } from "../../../../redux/crudSlice";
import { store } from "../../../../store/store";
import { LeadStageOptions } from "./entity";
var dispatch = store.dispatch;
export var CRMKeys = {
    paging: 'pagingCRM',
    get: 'crmCustomerGet',
    vehicleServiceHistory: 'crmVehicleServiceHistory',
    communicationHistory: 'crmVehicleCommunicationHistory',
    communicationTemplateList: 'crmCommunicationTemplateList',
    createComHistory: 'crmCreateCommunicationHistory',
    aiScript: 'crmAiScript',
    daySlots: 'daySlots',
    timeSlots: 'timeSlots'
};
export var crmCustomerVehiclePagingAPI = "".concat(Config.baseURL, "CRMCustomerVehicle/Paging");
export var crmCustomerGetAPI = function (id) { return "".concat(Config.baseURL, "CRMCustomer/").concat(id, "/Get"); };
export var crmVehicleServiceHistoryByVinAPI = "".concat(Config.baseURL, "CRMVehicalServiceHistory/ByVin");
export var crmCustomerCommunicationHistoryAPI = "".concat(Config.baseURL, "CRMCustomerCommunicationHistory/ByCustomerId");
export var crmCommunicationTemplatesAPI = "".concat(Config.baseURL, "CRMCommunicationTemplate/ByChannelType");
export var crmCreateComHistoryAPI = "".concat(Config.baseURL, "CRMCustomerCommunicationHistory/Create");
export var crmAiScriptGeneratorAPI = "".concat(Config.baseURL, "CRMCustomer/AIScript");
export var crmCallCustomerAPI = "https://rest.telecmi.com/v2/ind/click2call";
export var crmTelecmiLoginAPI = "https://rest.telecmi.com/v2/user/login";
export var crmSendEmail = "".concat(Config.baseURL, "CRMCustomer/SendEmail");
export var crmCustomerVehiclePaging = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _res$payload2, _res$payload3, _a, key, _b, request, _c, url, res, data;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? CRMKeys.paging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? crmCustomerVehiclePagingAPI : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                data = res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 ? void 0 : _res$payload.data;
                dispatch(setReducerState({
                    key: key,
                    value: _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value), {}, {
                        data: [data, data, data].flat().map(function (obj) { return _objectSpread(_objectSpread({}, obj), {}, {
                            id: nanoid(6)
                        }); })
                    })
                }));
                return [2 /*return*/, res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.value];
        }
    });
}); };
export var crmVehicleHistoryList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload4, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? CRMKeys.vehicleServiceHistory : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? crmVehicleServiceHistoryByVinAPI : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.value];
        }
    });
}); };
export var crmCommunicationHistroyList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload5, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? CRMKeys.vehicleServiceHistory : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? crmCustomerCommunicationHistoryAPI : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 ? void 0 : _res$payload5.value];
        }
    });
}); };
export var crmCommunicationTemplateList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload6, _a, key, _b, request, _c, url, state, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? CRMKeys.communicationTemplateList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? crmCommunicationTemplatesAPI : _c, state = params.state;
                request.ChannelType = state === null || state === void 0 ? void 0 : state.ChannelType;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.value];
        }
    });
}); };
export var crmCreateComHistory = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload7, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? CRMKeys.createComHistory : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? crmCreateComHistoryAPI : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.value];
        }
    });
}); };
export var crmAiScriptGen = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _request$FirstName, _request$LastName, _request$Vehicle, _request$Vehicle2, _request$Vehicle3, _request$Vehicle4, _request$Vehicle5, _request$Insurance, _request$Insurance2, _request$Insurance3, _request$CRMAMC$0$Dis, _request$CRMAMC, _res$payload8, _a, key, _b, request, _c, url, req, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? CRMKeys.aiScript : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? crmAiScriptGeneratorAPI : _c;
                req = {
                    "Language": request === null || request === void 0 ? void 0 : request.Language,
                    "CustomerName": "".concat((_request$FirstName = request === null || request === void 0 ? void 0 : request.FirstName) !== null && _request$FirstName !== void 0 ? _request$FirstName : '', " ").concat((_request$LastName = request === null || request === void 0 ? void 0 : request.LastName) !== null && _request$LastName !== void 0 ? _request$LastName : ''),
                    "VehicleRegistrationNo": request === null || request === void 0 || (_request$Vehicle = request.Vehicle) === null || _request$Vehicle === void 0 ? void 0 : _request$Vehicle.RegistrationNo,
                    "VehicleModel": request === null || request === void 0 || (_request$Vehicle2 = request.Vehicle) === null || _request$Vehicle2 === void 0 ? void 0 : _request$Vehicle2.ProductName,
                    "VehiclePurchaseDate": dayjs(request === null || request === void 0 || (_request$Vehicle3 = request.Vehicle) === null || _request$Vehicle3 === void 0 ? void 0 : _request$Vehicle3.SellingInvoiceDate).format('YYYY-MM-DD'),
                    // "CustomerCode": request?.Code,
                    // "PrimaryMobileNumber": request?.MobileNumber,
                    // "Email": request?.Email,
                    "LastOdometerReading": request === null || request === void 0 || (_request$Vehicle4 = request.Vehicle) === null || _request$Vehicle4 === void 0 ? void 0 : _request$Vehicle4.LastKMReading,
                    // "LastServiceDate": dayjs(request?.LastServiceDate).format('YYYY-MM-DD'),
                    "NextServiceDueDate": dayjs(request === null || request === void 0 || (_request$Vehicle5 = request.Vehicle) === null || _request$Vehicle5 === void 0 ? void 0 : _request$Vehicle5.NextServiceDueDate).format('YYYY-MM-DD'),
                    "InsuranceName": request === null || request === void 0 || (_request$Insurance = request.Insurance) === null || _request$Insurance === void 0 ? void 0 : _request$Insurance.Name,
                    "InsurancePolicyNo": request === null || request === void 0 || (_request$Insurance2 = request.Insurance) === null || _request$Insurance2 === void 0 ? void 0 : _request$Insurance2.PolicyNumber,
                    "InsurancePolicyExpiryDate": dayjs(request === null || request === void 0 || (_request$Insurance3 = request.Insurance) === null || _request$Insurance3 === void 0 ? void 0 : _request$Insurance3.EndDate).format('YYYY-MM-DD'),
                    "BajajAMC": request !== null && request !== void 0 && request.AMCIsExpired ? 'Yes' : 'No',
                    "RSAExpiryDate": dayjs(request === null || request === void 0 ? void 0 : request.RSAExpiryDate).format('YYYY-MM-DD'),
                    // "CommunicationThrough": request?.CallPreference?.CommunicationPreference,
                    "VehicleWarrantyExpire": dayjs(request === null || request === void 0 ? void 0 : request.WarrantyExpiry).format('YYYY-MM-DD'),
                    "AnniversaryDate": request !== null && request !== void 0 && request.DateofAnniversary ? dayjs(request === null || request === void 0 ? void 0 : request.DateofAnniversary).format('YYYY-MM-DD') : dayjs().subtract(3, 'months').format('YYYY-MM-DD'),
                    "BirthDate": dayjs(request === null || request === void 0 ? void 0 : request.DateOfBirth).format('YYYY-MM-DD'),
                    "ServiceDropProbability": request === null || request === void 0 ? void 0 : request.ServiceDropProbability,
                    "LoyaltyPoints": request === null || request === void 0 ? void 0 : request.LoyaltyPoints,
                    "DiscountOffer": "".concat((_request$CRMAMC$0$Dis = request === null || request === void 0 || (_request$CRMAMC = request.CRMAMC) === null || _request$CRMAMC === void 0 || (_request$CRMAMC = _request$CRMAMC[0]) === null || _request$CRMAMC === void 0 ? void 0 : _request$CRMAMC.Discount) !== null && _request$CRMAMC$0$Dis !== void 0 ? _request$CRMAMC$0$Dis : 0),
                    // "ComplaintStatus": request?.Complaint?.ComplaintStatus,
                    "CustomerFeedbackScore": request === null || request === void 0 ? void 0 : request.NPS
                };
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: req
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.value];
        }
    });
}); };
export var crmCustomerProfileGet = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload9, _res$payload10, _res$payload11, _res$payload12, _serviceHistory$data, _serviceHistory$data2, _serviceHistory$data3, _res$payload13, _res$payload14, _res$payload15, _a, key, _b, request, _c, url, res, serviceHistory, data;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? CRMKeys.get : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? crmCustomerGetAPI(request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                if (!(res !== null && res !== void 0 && (_res$payload9 = res.payload) !== null && _res$payload9 !== void 0 && (_res$payload9 = _res$payload9.value) !== null && _res$payload9 !== void 0 && _res$payload9.success))
                    return [2 /*return*/, res === null || res === void 0 || (_res$payload10 = res.payload) === null || _res$payload10 === void 0 ? void 0 : _res$payload10.value];
                return [4 /*yield*/, crmVehicleHistoryList({
                        key: key,
                        request: {
                            Vin: res === null || res === void 0 || (_res$payload11 = res.payload) === null || _res$payload11 === void 0 || (_res$payload11 = _res$payload11.value) === null || _res$payload11 === void 0 || (_res$payload11 = _res$payload11.data) === null || _res$payload11 === void 0 || (_res$payload11 = _res$payload11.Vehicle) === null || _res$payload11 === void 0 ? void 0 : _res$payload11.Vin,
                            skip: 0,
                            take: 3,
                            orderby: 'ServiceDate',
                            asc: -1
                        }
                    })];
            case 2:
                serviceHistory = _d.sent();
                data = _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload12 = res.payload) === null || _res$payload12 === void 0 || (_res$payload12 = _res$payload12.value) === null || _res$payload12 === void 0 ? void 0 : _res$payload12.data), {}, {
                    ServiceHistoryList: serviceHistory === null || serviceHistory === void 0 ? void 0 : serviceHistory.data,
                    NPS: serviceHistory === null || serviceHistory === void 0 || (_serviceHistory$data = serviceHistory.data) === null || _serviceHistory$data === void 0 || (_serviceHistory$data = _serviceHistory$data[0]) === null || _serviceHistory$data === void 0 ? void 0 : _serviceHistory$data.NPSScore,
                    Complaint: serviceHistory === null || serviceHistory === void 0 || (_serviceHistory$data2 = serviceHistory.data) === null || _serviceHistory$data2 === void 0 ? void 0 : _serviceHistory$data2[0],
                    LastServiceDate: serviceHistory === null || serviceHistory === void 0 || (_serviceHistory$data3 = serviceHistory.data) === null || _serviceHistory$data3 === void 0 || (_serviceHistory$data3 = _serviceHistory$data3[0]) === null || _serviceHistory$data3 === void 0 ? void 0 : _serviceHistory$data3.ServiceDate,
                    Language: 'English',
                    InsuranceDue: res === null || res === void 0 || (_res$payload13 = res.payload) === null || _res$payload13 === void 0 || (_res$payload13 = _res$payload13.value) === null || _res$payload13 === void 0 || (_res$payload13 = _res$payload13.data) === null || _res$payload13 === void 0 || (_res$payload13 = _res$payload13.Insurance) === null || _res$payload13 === void 0 ? void 0 : _res$payload13.EndDate,
                    ServiceDue: res === null || res === void 0 || (_res$payload14 = res.payload) === null || _res$payload14 === void 0 || (_res$payload14 = _res$payload14.value) === null || _res$payload14 === void 0 || (_res$payload14 = _res$payload14.data) === null || _res$payload14 === void 0 || (_res$payload14 = _res$payload14.Vehicle) === null || _res$payload14 === void 0 ? void 0 : _res$payload14.NextServiceDueDate,
                    LeadStageCategory: LeadStageOptions[0],
                    LeadStageStatus: LeadStageOptions[0].Status,
                    IncludeStage: LeadStageOptions[0].Status > -1
                });
                crmAiScriptGen({
                    request: data
                });
                return [2 /*return*/, _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload15 = res.payload) === null || _res$payload15 === void 0 ? void 0 : _res$payload15.value), {}, {
                        data: data
                    })];
        }
    });
}); };
export var crmCustomerCall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _loginRes$data, _callRes, _callRes4, _callRes5, request, loginRes, mobile, callRes, _callRes2, _callRes3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                request = params.request;
                return [4 /*yield*/, axios.post(crmTelecmiLoginAPI, {
                        "id": "4001_33334905",
                        "password": "kunals@123"
                    })];
            case 1:
                loginRes = _a.sent();
                if ((loginRes === null || loginRes === void 0 || (_loginRes$data = loginRes.data) === null || _loginRes$data === void 0 ? void 0 : _loginRes$data.code) !== 200)
                    return [2 /*return*/, loginRes === null || loginRes === void 0 ? void 0 : loginRes.data];
                mobile = Number("91".concat(request === null || request === void 0 ? void 0 : request.MobileNumber));
                return [4 /*yield*/, axios.post(crmCallCustomerAPI, {
                        "token": loginRes.data.token,
                        "to": mobile,
                        "extra_params": {
                            "crm": "true"
                        },
                        "callerid": Math.ceil(Math.random() * 1e12)
                    })];
            case 2:
                callRes = _a.sent();
                if (((_callRes = callRes) === null || _callRes === void 0 || (_callRes = _callRes.data) === null || _callRes === void 0 ? void 0 : _callRes.code) === 200) {
                    dispatch(showSuccess((_callRes2 = callRes) === null || _callRes2 === void 0 || (_callRes2 = _callRes2.data) === null || _callRes2 === void 0 ? void 0 : _callRes2.msg));
                }
                else {
                    dispatch(showError(((_callRes3 = callRes) === null || _callRes3 === void 0 || (_callRes3 = _callRes3.data) === null || _callRes3 === void 0 ? void 0 : _callRes3.msg) || 'Failed to initiate call'));
                }
                return [2 /*return*/, _objectSpread({
                        success: ((_callRes4 = callRes) === null || _callRes4 === void 0 || (_callRes4 = _callRes4.data) === null || _callRes4 === void 0 ? void 0 : _callRes4.code) === 200
                    }, (_callRes5 = callRes) === null || _callRes5 === void 0 ? void 0 : _callRes5.data)];
        }
    });
}); };
export var getDaySlots = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload16, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? CRMKeys.daySlots : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getAppointmnetSlotsUrl : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload16 = res.payload) === null || _res$payload16 === void 0 ? void 0 : _res$payload16.value];
        }
    });
}); };
export var getTimeSlots = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload17, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? CRMKeys.timeSlots : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getSlotAPI : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload17 = res.payload) === null || _res$payload17 === void 0 ? void 0 : _res$payload17.value];
        }
    });
}); };
export var sendEmail = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _request$Name, _a, request, _b, url, req, res;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = params.request, request = _a === void 0 ? {} : _a, _b = params.url, url = _b === void 0 ? crmSendEmail : _b;
                req = {
                    to: request === null || request === void 0 ? void 0 : request.Value,
                    // Change to your recipient
                    subject: 'Book appointment',
                    body: request.MessageText,
                    html: "\n        Hi ".concat((_request$Name = request === null || request === void 0 ? void 0 : request.Name) !== null && _request$Name !== void 0 ? _request$Name : '', ",</br></br>\n        <a href=\"https://dev-idms-v3-0.excellonconnect.com/customerAppointment?vin=").concat(request === null || request === void 0 ? void 0 : request.VinNo, "\">Click here</a> to book an appointment.</br></br>\n        Regards,</br>\n        Bajaj Customer Support\n        ")
                };
                return [4 /*yield*/, dispatch(createAPI({
                        key: '',
                        url: url,
                        request: req
                    }))];
            case 1:
                res = _c.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload];
        }
    });
}); };
export var sendCommunication = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _await$crmCreateComHi, _a, request, res, emailRes, _request$Value, callRes;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = params.request, request = _a === void 0 ? {} : _a;
                res = {};
                if (!((request === null || request === void 0 ? void 0 : request.ChannelType) === 'Email' && (request === null || request === void 0 ? void 0 : request.Template) === 'Appointment Link')) return [3 /*break*/, 2];
                return [4 /*yield*/, sendEmail({
                        request: request
                    })];
            case 1:
                emailRes = _b.sent();
                if (emailRes !== null && emailRes !== void 0 && emailRes.success) {
                    dispatch(showSuccess('Email sent successfully!'));
                    request.ResponseStatus = 'Sent';
                }
                else {
                    dispatch(showError('Failed to send email'));
                    return [2 /*return*/, emailRes !== null && emailRes !== void 0 ? emailRes : res];
                }
                _b.label = 2;
            case 2:
                if (!((request === null || request === void 0 ? void 0 : request.ChannelType) === 'Call')) return [3 /*break*/, 4];
                if ((request === null || request === void 0 || (_request$Value = request.Value) === null || _request$Value === void 0 ? void 0 : _request$Value.length) !== 10)
                    return [2 /*return*/, {}];
                return [4 /*yield*/, crmCustomerCall({
                        request: {
                            MobileNumber: request === null || request === void 0 ? void 0 : request.Value
                        },
                        state: request
                    })];
            case 3:
                callRes = _b.sent();
                if (callRes !== null && callRes !== void 0 && callRes.success)
                    request.MessageText = 'Call initiated';
                else
                    return [2 /*return*/, callRes !== null && callRes !== void 0 ? callRes : res];
                _b.label = 4;
            case 4: return [4 /*yield*/, crmCreateComHistory({
                    request: request
                })];
            case 5:
                res = (_await$crmCreateComHi = _b.sent()) !== null && _await$crmCreateComHi !== void 0 ? _await$crmCreateComHi : res;
                return [2 /*return*/, res];
        }
    });
}); };
